"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationStepBase = void 0;
const serviceBase_1 = require("./serviceBase");
const api_exceptions_1 = require("../exceptions/api_exceptions");
const fields_schema_1 = require("./fields_schema");
class IntegrationStepBase {
    constructor(model) {
        this.id = model.id;
        this.data = model.data;
        this.integrationId = model.integrationId;
        this.serviceId = model.serviceId;
        if (model.service) {
            this.service = new serviceBase_1.ServiceBase(model.service);
        }
    }
    async getService() {
        if (!this.service) {
            throw new Error("Missing integration step service.");
        }
        return this.service;
    }
    haveToConfigure() {
        var _a, _b;
        return IntegrationStepBase.haveToConfig((_b = (_a = this === null || this === void 0 ? void 0 : this.data) === null || _a === void 0 ? void 0 : _a.editor) === null || _b === void 0 ? void 0 : _b.mustConfig);
    }
    static haveToConfig(mustConfig) {
        return ((mustConfig === null || mustConfig === void 0 ? void 0 : mustConfig.configStep) ||
            (mustConfig === null || mustConfig === void 0 ? void 0 : mustConfig.mapInputFields) ||
            (mustConfig === null || mustConfig === void 0 ? void 0 : mustConfig.mapOutputFields));
    }
    /**
     * Return the mapping the output fields of this step to an EndUser
     *
     * @returns
     * @memberof IntegrationStep
     */
    // getFieldMappings() {
    //   const outputFields = this?.data?.outputFields;
    //   if (!outputFields) {
    //     return {};
    //   }
    //   const fieldMappings = _.reduce(
    //     outputFields,
    //     (acc, field) => {
    //       if (field.endUserField) {
    //         acc[field.key] = field.endUserField;
    //       }
    //       return acc;
    //     },
    //     {} as Dictionary<string>
    //   );
    //   return fieldMappings;
    // }
    getTriggerOffset() {
        var _a, _b, _c, _d;
        // Calculate the difference between the current time and for when the time trigger is scheduled
        const nowMs = Date.now();
        const triggerDateTime = (_d = (_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.data) === null || _a === void 0 ? void 0 : _a.inputFields) === null || _b === void 0 ? void 0 : _b.properties) === null || _c === void 0 ? void 0 : _c.datetime) === null || _d === void 0 ? void 0 : _d.value;
        if (!triggerDateTime) {
            throw new api_exceptions_1.InternalException("No date and time set for step.");
        }
        const triggerAtMs = new Date(triggerDateTime).getTime();
        // Protect against negative delay
        return Math.max(0, triggerAtMs - nowMs);
    }
    isTimeTrigger() {
        return this.data.operationKey === "/time" && this.serviceId === "encharge";
    }
    isEnteredOrLeftSegment() {
        return IntegrationStepBase.isEnteredOrLeftSegment({
            serviceId: this.serviceId,
            operationKey: this.data.operationKey,
        });
    }
    static isEnteredOrLeftSegment({ serviceId, operationKey, }) {
        return ((operationKey === "/entered-segment" ||
            operationKey === "/left-segment") &&
            serviceId === "encharge");
    }
    isDateFieldTrigger() {
        return ((this.data.operationKey === "/dateFieldTrigger" ||
            this.data.operationKey === "/annualTrigger") &&
            this.serviceId === "encharge");
    }
    isDelay() {
        return IntegrationStepBase.isDelay({
            operationKey: this.data.operationKey,
        });
    }
    static isDelay({ operationKey, }) {
        return operationKey === "/delay" || operationKey === "/delay-v2";
    }
    isFilter() {
        return IntegrationStepBase.isFilter({
            type: this.data.type,
        });
    }
    static isFilter({ type }) {
        return type === "filter";
    }
    isRecurringTimeTrigger() {
        return this.data.operationKey === "/recurring-time-trigger";
    }
    isSendEmail() {
        return IntegrationStepBase.isSendEmail({
            operationKey: this.data.operationKey,
        });
    }
    static isSendEmail({ operationKey, }) {
        return operationKey === "/send";
    }
    isEmailNotification() {
        return IntegrationStepBase.isEmailNotification({
            operationKey: this.data.operationKey,
            serviceId: this.serviceId,
        });
    }
    static isEmailNotification({ serviceId, operationKey, }) {
        return serviceId === "encharge" && operationKey === "/email-notification";
    }
    isEmailTrigger() {
        return (this.serviceId === "encharge" &&
            (this.data.operationKey === "/email-trigger" ||
                this.data.operationKey === "/email-trigger-v2"));
    }
    isSegmentEventTrigger() {
        return this.serviceId === "segment" && this.data.operationKey === "/event";
    }
    isTagTrigger() {
        return (this.serviceId === "encharge" &&
            (this.data.operationKey === "/added-tag" ||
                this.data.operationKey === "/removed-tag"));
    }
    isPageVisitTrigger() {
        return (this.serviceId === "encharge" &&
            this.data.operationKey === "/page-visited-trigger");
    }
    isSiteFormTrigger() {
        return (this.serviceId === "encharge" &&
            this.data.operationKey === "/site-form-submitted");
    }
    isNativeFormTrigger() {
        return (this.serviceId === "encharge" &&
            this.data.operationKey === "/native-form-submitted");
    }
    isChangeFieldTrigger() {
        return (this.serviceId === "encharge" &&
            this.data.operationKey === "/change-field-trigger");
    }
    async isTrigger() {
        return (await this.type) === "trigger";
    }
    isGoal() {
        return this.data.operationKey === "/flow-goal";
    }
    isWebhook() {
        return IntegrationStepBase.isWebhook({
            serviceId: this.serviceId,
            operationKey: this.data.operationKey,
        });
    }
    static isWebhook({ serviceId, operationKey, }) {
        return (serviceId === "encharge" &&
            (operationKey === "/submitted-form" ||
                operationKey === "/webhook-trigger" ||
                operationKey === "/send-webhook"));
    }
    isSendWebhook() {
        return IntegrationStepBase.isSendWebhook({
            serviceId: this.serviceId,
            operationKey: this.data.operationKey,
        });
    }
    static isSendWebhook({ serviceId, operationKey, }) {
        return serviceId === "encharge" && operationKey === "/send-webhook";
    }
    isIncomingWebhook() {
        return IntegrationStepBase.isIncomingWebhook({
            serviceId: this.serviceId,
            operationKey: this.data.operationKey,
        });
    }
    static isIncomingWebhook({ serviceId, operationKey, }) {
        return (serviceId === "encharge" &&
            (operationKey === "/submitted-form" ||
                operationKey === "/webhook-trigger"));
    }
    static isABTest({ serviceId, operationKey, }) {
        return serviceId === "encharge" && operationKey === "/ab-test";
    }
    get subscribeKey() {
        return this.getService().then((service) => service.getSubscribeForOperation(this.data.operationKey));
    }
    get description() {
        return this.getService().then((service) => service.getOperationDescription(this.data.operationKey));
    }
    get unsubscribeKey() {
        return this.getService().then((service) => service.getUnsubscribeOperation(this.data.operationKey));
    }
    get type() {
        return this.data.type;
    }
    get producesEndUsers() {
        return this.getService().then((service) => service.getEndUserFlagsForOperation(this.data.operationKey)
            .producesEndUsers);
    }
    get stepUpdateSource() {
        return this.getService().then((service) => service.getUpdateSourceForOperation(this.data.operationKey));
    }
    get consumesEndUsers() {
        return this.getService().then((service) => service.getEndUserFlagsForOperation(this.data.operationKey)
            .consumesEndUsers);
    }
    get triggerType() {
        return this.getService().then((service) => service.getTriggerTypeForOperation(this.data.operationKey) || undefined);
    }
    get teardownOperation() {
        return this.getService().then((service) => service.getTeardownForOperation(this.data.operationKey) || undefined);
    }
    get batch() {
        return this.getService().then((service) => {
            const flag = service.getBatchFlagForOperation(this.data.operationKey);
            if (flag === undefined || flag === null) {
                return false;
            }
            return flag;
        });
    }
    get idempotent() {
        return this.getService().then((service) => {
            const flag = service.getIdempotentFlagForOperation(this.data.operationKey);
            // we consider steps to be idempotent by default
            if (flag === undefined || flag === null) {
                return true;
            }
            return flag;
        });
    }
    get runOnce() {
        return this.getService().then((service) => {
            const flag = service.getRunOnceFlagForOperation(this.data.operationKey);
            if (flag === undefined || flag === null) {
                return false;
            }
            return flag;
        });
    }
    get skipLiquidTagReplacement() {
        return this.getService().then((service) => {
            const flag = service.getSkipLiquidTagReplacementFlagForOperation(this.data.operationKey);
            if (flag === undefined || flag === null) {
                return true;
            }
            return flag;
        });
    }
    get linkConditions() {
        return this.getService().then((service) => service.getLinkConditionsForOperation(this.data.operationKey));
    }
    get inputFieldsValues() {
        return new fields_schema_1.FieldsSchema(this.data.inputFields).getValues();
    }
    get outputMapping() {
        return new fields_schema_1.FieldsSchema(this.data.inputFields).getDeepProperty("endUserField");
    }
    get isUserInitiated() {
        return this.getService().then((service) => service.getIsUserInitiatedForOperation(this.data.operationKey));
    }
    get resultsAlreadyMappedToEndUsers() {
        return this.getService().then((service) => service.getResultsAlreadyMappedToEndUsersForOperation(this.data.operationKey));
    }
    isHighPriorityPollingStep() {
        return IntegrationStepBase.isHighPriorityPollingStep({
            serviceId: this.serviceId,
            operationKey: this.data.operationKey,
        });
    }
    static isHighPriorityPollingStep({ serviceId, operationKey, }) {
        return serviceId === "hubspot" && operationKey === "/forms/submissions";
    }
}
exports.IntegrationStepBase = IntegrationStepBase;
//# sourceMappingURL=integrationStepBase.js.map